import { render, staticRenderFns } from "./BrandBtn.vue?vue&type=template&id=895b0d7a&"
import script from "./BrandBtn.vue?vue&type=script&lang=js&"
export * from "./BrandBtn.vue?vue&type=script&lang=js&"
import style0 from "./BrandBtn.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports